import { gql } from "../../../__generated__";

export const GET_BANDS = gql(`
query bandsForPicker {
  bands {
    id
    name
  }
}
`);
